import { apiSlice } from './apiSlice';

export const accountingLedgerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Manual Journals
    getManualJournals: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/api/manual-journals',
        params: params || {},
      }),
      providesTags: ['ManualJournal'],
    }),
    getManualJournalById: builder.query<any, string | number>({
      query: (id) => ({ url: `/api/manual-journals/${id}` }),
      providesTags: (result, error, id) => [{ type: 'ManualJournal', id }],
    }),
    createManualJournal: builder.mutation<any, any>({
      query: (data) => ({
        url: '/api/manual-journals',
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['ManualJournal'],
    }),
    updateManualJournal: builder.mutation<any, { id: string | number; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/manual-journals/${id}`,
        method: 'PUT',
        data: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ManualJournal', id },
        'ManualJournal',
      ],
    }),
    deleteManualJournal: builder.mutation<void, string | number>({
      query: (id) => ({
        url: `/api/manual-journals/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ManualJournal'],
    }),

    reverseManualJournal: builder.mutation<any, { id: string | number; memo: string }>({
      query: ({ id, memo }) => ({ url: `/api/manual-journals/${encodeURIComponent(String(id))}/reverse`, method: 'POST', data: { memo } }),
      invalidatesTags: (result, error, { id }) => [{ type: 'ManualJournal', id }, 'ManualJournal', 'GLInquiry', 'AccountLedger', 'Accounting'],
    }),

    decideClosingJournal: builder.mutation<any, { id: string | number; decision: 'approve' | 'reject' }>({
      query: ({ id, decision }) => ({ url: `/api/manual-journals/${encodeURIComponent(String(id))}/${decision}-closing`, method: 'POST', data: {} }),
      invalidatesTags: (result, error, { id }) => [{ type: 'ManualJournal', id }, 'ManualJournal', 'GLInquiry', 'AccountLedger', 'Accounting', 'FiscalPeriod'],
    }),

    // GL Inquiry
    getGLDashboard: builder.query<any, void>({
      query: () => ({ url: '/api/gl-inquiry/dashboard' }),
      providesTags: ['GLInquiry'],
    }),
    searchGL: builder.query<any, Record<string, any>>({
      query: (params) => ({
        url: '/api/gl-inquiry/search',
        params,
      }),
      providesTags: ['GLInquiry'],
    }),
    getRunningBalances: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/api/gl-inquiry/running-balances',
        params: params || {},
      }),
      providesTags: ['GLInquiry'],
    }),
    refreshGl: builder.mutation<any, void>({
      query: () => ({
        url: '/api/gl-inquiry/refresh',
        method: 'POST',
      }),
      invalidatesTags: ['GLInquiry', 'ManualJournal', 'AccountLedger'],
    }),

    // Account Ledger
    getAccountLedger: builder.query<any, { accountId: string | number; params?: Record<string, any> }>({
      query: ({ accountId, params }) => ({
        url: `/api/accounts/${accountId}/ledger`,
        params,
      }),
      providesTags: ['AccountLedger'],
    }),
  }),
});

export const {
  useGetManualJournalsQuery,
  useGetManualJournalByIdQuery,
  useCreateManualJournalMutation,
  useUpdateManualJournalMutation,
  useDeleteManualJournalMutation,
  useReverseManualJournalMutation,
  useDecideClosingJournalMutation,
  useGetGLDashboardQuery,
  useSearchGLQuery,
  useLazySearchGLQuery,
  useGetRunningBalancesQuery,
  useRefreshGlMutation,
  useGetAccountLedgerQuery,
} = accountingLedgerApi;
